import { IMAGES } from "../../lib/brand";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative w-full bg-[#F6F2EC]"
    >
      {/* Full-bleed editorial image */}
      <div className="relative w-full h-[100svh] overflow-hidden">
        <img
          src={IMAGES.hero}
          alt="Three women laughing together in shimmering luxury evening dresses at a glamorous event"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition: "center 20%" }}
        />

        {/* Headline — smaller, refined, restrained */}
        <div className="absolute inset-0 flex items-end">
          <div className="w-full mx-auto max-w-[1480px] px-6 md:px-10 lg:px-14 pb-16 md:pb-20">
            <h1
              data-testid="hero-headline"
              className="font-editorial text-[#F6F2EC] text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-3xl rise"
              style={{ textShadow: "0 1px 18px rgba(43,35,32,0.22)" }}
            >
              One shared wardrobe.
              <br />
              <span className="font-editorial-italic">Endless moments.</span>
            </h1>
          </div>
        </div>
      </div>

      {/* Cream sub-strip — tighter, intentional transition */}
      <div className="w-full bg-[#F6F2EC]">
        <div className="mx-auto max-w-[1180px] px-6 md:px-10 lg:px-14 pt-14 md:pt-20 pb-16 md:pb-20 text-center">
          <p
            data-testid="hero-tenet"
            className="font-editorial-italic text-[#634F50] text-lg md:text-xl leading-relaxed"
          >
            Access is complimentary. Trust is earned. Entry is curated.
          </p>

          <p
            data-testid="hero-subheadline"
            className="mt-10 md:mt-12 font-editorial text-[#2B2320] text-xl md:text-2xl lg:text-3xl leading-snug max-w-3xl mx-auto"
          >
            A curated fashion platform for discovering, renting, and lending coveted pieces through a more thoughtful,{" "}
            <span className="font-editorial-italic">white-glove</span> experience.
          </p>

          <div className="mt-10 md:mt-12">
            <a
              href="https://tally.so/r/VLv7Ey"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-waitlist-button"
              className="eyebrow text-[#2B2320] border-b border-[#2B2320] pb-2 transition-opacity hover:opacity-60"
            >
              Join the Waitlist
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
